import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';

import { FirebaseToken } from '../../app/core/firebase.module';
import { Firestore } from 'firebase/firestore';
import { OperationLogsDefaultProvider, OperationLogsProvider } from './operation-logs.provider';
import { AuthProvider } from '../auth/auth.provider';
import { CreateOperationLogInteractor } from './domain/interactors/create-operation-log.interactor';

@NgModule({
  providers: angularProvidersBuilder({
    provide: OperationLogsProvider,
    deps: [AuthProvider, FirebaseToken.Firestore],
    useFactory: (authProvider: AuthProvider, firestore: Firestore) =>
      new OperationLogsDefaultProvider(authProvider, firestore),
  })
    .add(CreateOperationLogInteractor, (p) => p.provideCreateOperationLog())
    .build(),
})
export class OperationLogsProviderModule {}
